
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PricingHero from './components/PricingHero';
import PricingPlans from './components/PricingPlans';
import PricingFAQ from './components/PricingFAQ';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-dark text-beige-light font-sans">
      <Navbar />
      <main>
        <PricingHero />
        <PricingPlans />
        <PricingFAQ />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
